import React,{useState,useEffect} from "react";
import {Link} from 'react-router-dom';
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";
import "./Dashboard.scss";
import IssuesFound from "../../assets/images/issues_found.svg";
import CriticalThreats from "../../assets/images/critical_threats.svg";
import OutdatedPlugins from "../../assets/images/outdated_plugins.svg";
import FailedLogins from "../../assets/images/failed_logins.svg";
import Good from "../../assets/images/good.svg";
import Critical from "../../assets/images/critical.svg";
import FaileLoginAttempt from "../../assets/images/failed_login_attempt.svg";
import ipReload from '../../assets/images/ipReload.svg';


export default function Dashboard() {
    const [logs, setLogs] = useState([]);
    const [totalFailed, setTotalFailed] = useState(0);
    const [recentFailed, setRecentFailed] = useState(0);
	const [updatedPluginList, setUpdatedPluginList] = useState([]);
	const [outdatedPLuginsNumber, setOutdatedPLuginsNumber] = useState(0);
	const [siteHealthReport, setSiteHealthReport] = useState([]);
	const [siteHealthStatus, setSiteHealthStatus] = useState('');
	const [totalIssues, setTotalIssues] = useState(0);
	const [criticalThreats, setCriticalThreats] = useState(0);
	const [loading, setLoading] = useState(false);

	const refreshAll = () => {
		// Set loading to true to start the rotation
		setLoading(true);
		
		// Fetch data
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
		
		// Ensure the rotation lasts at least 1 second
		setTimeout(() => {
		  setLoading(false);
		}, 1000);
	  }
	useEffect(()=> {
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
	},[])

	

	const fetchLogs = async () => {
		try {
			const results = await apiFetch({
				path: "/ultimate-security/v1/get-login-failed-logs",
				method: "GET"
			});

			setTotalFailed(results.total_failed || 0);
			setRecentFailed(results.recent_failed || 0);
			setLogs(results.logs || []);
		} catch (error) {
			console.error("Error fetching logs:", error);
		}
	};

	
	const fetchPluginList = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/update-plugin-info", 
				method: "GET" 
			});
			
			// console.log("Raw API response:", results);
	
			const pluginList = Array.isArray(results.plugins_with_updates) ? results.plugins_with_updates : [];
			
			// Log the first plugin object to check its structure
			if (pluginList.length > 0) {
				console.log("First plugin object:", pluginList[0]);
				console.log("Current version value:", pluginList[0].current_version);
				console.log("Properties in first plugin:", Object.keys(pluginList[0]));
			}
	
			setUpdatedPluginList(pluginList);
			setOutdatedPLuginsNumber(pluginList.length);
	
		} catch (error) {
			console.error("Error fetching PluginList:", error);
			setUpdatedPluginList([]); // fallback to empty list
			setOutdatedPLuginsNumber(0); // reset count
		}
	};
	
	const fetchSiteHealthReport = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/site-health-report", 
				method: "GET" 
			});
			// console.log(results);
			setSiteHealthStatus(results.status);
			setTotalIssues(results.total_issues);
			setCriticalThreats(results.critical_count);
			setSiteHealthReport(results.critical_issues);
			
			
		} catch (error) {
			console.error("Error fetching Report:", error);
		}
	};


	return (
		<div className="usfw-dashboard-content">
			<div className="mb-4 text-end">
				
				<img className={loading ?'rotate':''} src={ipReload} alt="" onClick={refreshAll} />
			</div>
			<div className="row mb-4">
				{/* Top stats cards */}
				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-3 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={IssuesFound} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{totalIssues}</h2>
								<p className="text-text mb-0 small">
									Issues Found
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-3 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={CriticalThreats} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{criticalThreats}</h2>
								<p className="text-text mb-0 small">
									Critical Threats
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-3 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={OutdatedPlugins} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{outdatedPLuginsNumber}</h2>
								<p className="text-text mb-0 small">
									Outdated Plugins
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
							
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-3 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={FailedLogins} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{totalFailed}</h2>
								<p className="text-text mb-0 small">
									Failed Logins
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row mb-4">
				{/* Middle section */}
				<div className="col-md-3">
					<div className="dash-card " style={{height: "216px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">
								Failed Login Attempts
							</h5>
							<div className="d-flex align-items-center">
								<div
									className=" me-4 d-flex align-items-center justify-content-center"
									style={{ width: "90px", height: "85px" }}
								>
									 <img src={FaileLoginAttempt} alt="icon" />
									{/* <h2 className=" mb-0 fw-bold">{recentFailed}</h2> */}
								</div>
								<div>
									<p className="mb-0 fw-medium">
										{recentFailed>0 ? recentFailed : "Hooray! Zero "} failed login attempts in the (past 24 hours)
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "216px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">Security Status</h5>
							<div className="d-flex align-items-center">
								<div
									className="bg-primary bg-opacity-10 text-primary rounded-circle p-3 me-4 d-flex align-items-center justify-content-center"
									style={{ width: "64px", height: "64px" }}
								>
									<img src={siteHealthStatus === "good" ? Good : Critical } alt="iocn" />
								</div>
								<div>
									<h4 className="pl-heading fw-bold mb-1">{siteHealthStatus}</h4>
									<p className="mb-0">
										{siteHealthStatus === "good" ? "Your site is protected and no issues detected." : "Your site is not protected."}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Bottom section */}
				<div className="col-md-6">
					<div className="dash-card " style={{height: "216px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">Login Logs</h5>
							<ul className="list-unstyled">
								{logs.map((log, index) => (
									<li key={index} className="mb-2">
										{log.success ? "✓" : "✗"}{" "}
										<strong>{log.success ? "Successful" : "Failed"}</strong> login by{" "}
										<code>{log.username}</code> at{" "}
										{new Date(log.timestamp * 1000).toLocaleString()} from{" "}
										<code>{log.ip}</code>
									</li>
								))}
							</ul>

						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-6">
					<div className="dash-card " style={{height: "240px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<h5 className="card-title mb-0">
									Critical Threats
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'site-health.php'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									VIEW ALL
								</a>
							</div>
							<ul className="list-unstyled mb-0">
								{siteHealthReport.slice(0, 5).map((report, index) => (
									<li key={index} className="mb-2">
										<span className="pl-heading-1fw-bold text-danger">{report.label}</span>
									</li>
								))}
								
							</ul>
						</div>
					</div>
				</div>

				<div className="col-md-6">
					<div className="dash-card " style={{height: "240px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<h5 className="card-title mb-0">
									Plugin Updates
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'plugins.php?plugin_status=upgrade'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									VIEW UPDATES
								</a>
								
								{/* <Link to="/more/misc/updates" className="text-decoration-none small" style={{color: "#873EFF"}}>
									{__( 'VIEW UPDATES', "ultimate-security" )}
								</Link> */}
								
							</div>
							<ul className="list-unstyled mb-0">
								{updatedPluginList.slice(0, 5).map((plugin, index) => (
								<li key={index} className="mb-2">
									{plugin.name} - <span className="fw-bold text-danger">
									{plugin.current_version || "Unknown"} → {plugin.new_version}
									</span>
								</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
